import { CloseCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const NoAudioBookFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-[80vh] rounded-lg p-6">
      <CloseCircleOutlined className="text-gray-400 dark:text-stone-600 text-6xl" />
      <p className="mt-8 text-lg font-semibold text-gray-600 dark:text-stone-300">
        No Audio Book is found or there is an error
      </p>
      <p className="mt-8 text-sm text-gray-500 dark:text-stone-400">
        Please pick another category/Collections or try checking your internet
      </p>
      <button
        onClick={() => navigate("/users/home")}
        className="mt-8 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 dark:hover:bg-blue-500 transition"
      >
        Explore Audiobooks
      </button>
    </div>
  );
};

export default NoAudioBookFound;
